// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field.v-text-field--enclosed .v-text-field__details{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
